import React from 'react';
import ContactUs from '../components/3_Organisms/ContactUs/ContactUs';
import EVBatteryCalculator from '../components/3_Organisms/EVBatteryCalculator/EVBatteryCalculator';
import EVRangeMap from '../components/3_Organisms/EVRangeMap/EVRangeMap';
import FindADealer from '../components/3_Organisms/FindADealer/FindADealer';
import KMI from '../components/3_Organisms/KMI/KMI';
import KMIModal from '../components/3_Organisms/KMI/KMIModal';
import SaveBuildModal from '../components/3_Organisms/SaveBuildModal/SaveBuildModal';
import SendBuildToDealer from '../components/3_Organisms/SendBuildToDealer/SendBuildToDealer';
import ShareBuildModal from '../components/3_Organisms/ShareBuildModal/ShareBuildModal';
import BookServiceAppointment from '../components/5_Pages/BookServiceAppointment/BookServiceAppointment';
import BookTestDriveContainer from '../components/5_Pages/BookTestDrive/BookTestDriveContainer';
import GetQuoteContainer from '../components/5_Pages/GetQuote/GetQuoteContainer';
import ReserveYourMazdaContainer from '../components/5_Pages/ReserveYourMazda/ReserveYourMazda.container';
import PreOrderContainer from '../components/5_Pages/PreOrder/PreOrder.container';
import SpecCompare from '../components/5_Pages/SpecCompare/SpecCompare';
import TradeInEstimatorContainer from '../components/5_Pages/TradeInEstimator/TradeInEstimatorContainer';
import VehicleAccessories from '../components/5_Pages/VehicleAccessories/VehicleAccessories';
import Nomination from '../components/3_Organisms/Nomination/Nomination';
import NominationModal from '../components/3_Organisms/Nomination/NominationModal';

export const KMI_Block = (props) => <KMI {...props} />;
export const KMIModal_Block = (props) => <KMIModal {...props} />;
export const ContactUs_Block = (props) => <ContactUs {...props} />;
export const FindADealer_Block = (props) => <FindADealer {...props} />;
export const BookTestDrive_Block = (props) => <BookTestDriveContainer {...props} />;
export const GetQuote_Block = (props) => <GetQuoteContainer {...props} />;
export const ReserveYourMazda_Block = (props) => <ReserveYourMazdaContainer {...props} />;
export const PreOrder_Block = (props) => <PreOrderContainer {...props} />;
export const TradeInEstimator_Block = (props) => <TradeInEstimatorContainer {...props} />;
export const BookServiceAppointment_Block = (props) => <BookServiceAppointment {...props} />;
export const EVRangeMap_Block = (props) => <EVRangeMap {...props} />;
export const SaveBuildModal_Block = (props) => <SaveBuildModal {...props} />;
export const ShareBuildModal_Block = (props) => <ShareBuildModal {...props} />;
export const SendBuildToDealer_Block = (props) => <SendBuildToDealer {...props} />;
export const EVBatteryCalculator_Block = (props) => <EVBatteryCalculator {...props} />;
export const SpecCompare_Block = (props) => <SpecCompare {...props} />;
export const VehicleAccessories_Block = (props) => <VehicleAccessories {...props} />;
export const Nomination_Block = (props) => <Nomination {...props} />;
export const NominationModal_Block = (props) => <NominationModal {...props} />;